var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white",
    stroke: "#9193A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.45V25M24.1667 17.45V25M15.8333 17.45V25M20.3725 12.5884L26.8425 15.845C27.6292 16.2409 27.3492 17.4342 26.47 17.4342H13.53C12.6508 17.4342 12.3708 16.2409 13.1575 15.845L19.6275 12.5884C19.7432 12.5306 19.8707 12.5005 20 12.5005C20.1293 12.5005 20.2568 12.5306 20.3725 12.5884ZM26.25 27.5H13.75C13.4185 27.5 13.1005 27.3683 12.8661 27.1339C12.6317 26.8995 12.5 26.5816 12.5 26.25C12.5 25.9185 12.6317 25.6006 12.8661 25.3662C13.1005 25.1317 13.4185 25 13.75 25H26.25C26.5815 25 26.8995 25.1317 27.1339 25.3662C27.3683 25.6006 27.5 25.9185 27.5 26.25C27.5 26.5816 27.3683 26.8995 27.1339 27.1339C26.8995 27.3683 26.5815 27.5 26.25 27.5Z",
    stroke: "#8A8A8A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.88cf8aeae41b367758a7376cfd1cd4d9.svg";
export { ForwardRef as ReactComponent };